{
	"title": "Shortlist",
	"common": {
		"loadFailed": "The shortlist could not be loaded",
		"tryAgain": "Try again"
	},
	"help": {
		"button": "How it works",
		"title": "How the shortlist works",
		"steps": {
			"registered": {
				"title": "Approved athletes",
				"body": "Every athlete with an approved card for the sport is listed. Others appear once the host approves them in View Records."
			},
			"select": {
				"title": "Select events",
				"body": "Mark each athlete Primary or Reserve per event, then save. Only shortlisted athletes can be entered in competition."
			},
			"deadline": {
				"title": "Deadline",
				"body": "Entries can be changed until the deadline the host sets. After it they lock; only the host can extend it."
			}
		},
		"quota": "Primary athletes count against the event's shortlist quota per organization. Where an event sets none, its entry quota applies (for team events, the number of teams times the largest team size). Reserves do not count.",
		"ovr": "Competition results (OVR) only accept athletes shortlisted for that event. Someone already entered in an event cannot be removed from its shortlist until the entry is withdrawn.",
		"standard": "Some events have a qualifying standard. A Primary athlete there needs a best record that meets it; a Reserve needs none. Type the record the way the sport writes it: a time like 1:58.50, a distance like 7.20."
	},
	"list": {
		"subtitle": "{{org}} · Accreditation",
		"contingent": "Contingent",
		"pickContingent": "Choose a contingent",
		"pickTitle": "Choose a contingent",
		"pickHint": "Pick the contingent whose athletes you want to enter, at the top of the page.",
		"tiles": {
			"aria": "Shortlist summary",
			"sports": "Sports",
			"primary": "Primary entries",
			"reserveSmall_one": "{{n}} reserve",
			"reserveSmall_other": "{{n}} reserves"
		},
		"sports": "Sports",
		"count_one": "{{n}} sport",
		"count_other": "{{n}} sports",
		"search": "Search sports",
		"sort": {
			"athletes": "Most athletes",
			"primary": "Most primary",
			"left": "Still to enter",
			"name": "Name A–Z"
		},
		"empty": {
			"filteredTitle": "No sports match",
			"filteredHint": "Try another name, or clear the filters.",
			"noneTitle": "No sports yet",
			"noneHint": "Sports appear here once the Games' sports and events are set up.",
			"clear": "Clear filters"
		},
		"nocOption": "{{code}} · {{name}}",
		"tabs": {
			"label": "View",
			"sports": "Sports",
			"athletes": "Athletes"
		}
	},
	"overview": {
		"subtitle": "All contingents · Accreditation",
		"back": "All contingents",
		"tiles": {
			"aria": "Contingents summary",
			"nocs": "Contingents"
		},
		"state": {
			"not_started": "Not started",
			"in_progress": "In progress",
			"closed": "Closed"
		},
		"search": "Search by name or country code",
		"chips": {
			"state": "Progress"
		},
		"col": {
			"noc": "Contingent",
			"athletes": "Athletes",
			"primary": "Primary",
			"reserve": "Reserve",
			"state": "Progress"
		},
		"pageSummary_one": "{{from}}–{{to}} of {{n}} contingent",
		"pageSummary_other": "{{from}}–{{to}} of {{n}} contingents",
		"empty": {
			"filteredTitle": "No contingents match",
			"noneTitle": "No contingents",
			"noneHint": "Contingents appear here once their organisations are set up and in your scope."
		}
	},
	"card": {
		"primary": "Primary",
		"reserve": "Reserve",
		"athletes": "Athletes",
		"events_one": "{{n}} event",
		"events_other": "{{n}} events"
	},
	"eventGender": {
		"MEN": "Men",
		"WOMEN": "Women",
		"MIXED": "Mixed",
		"OPEN": "Open"
	},
	"competitorType": {
		"INDIVIDUAL": "Individual",
		"TEAM": "Team entry"
	},
	"gender": {
		"MALE": "Man",
		"FEMALE": "Woman",
		"unknown": "Gender not recorded"
	},
	"role": {
		"PRIMARY": "Primary",
		"RESERVE": "Reserve",
		"NONE": "Not entered",
		"remove": "Remove {{name}} from the {{event}} shortlist",
		"removeHint": "Remove from the shortlist",
		"short": {
			"PRIMARY": "P",
			"RESERVE": "R"
		},
		"hint": {
			"PRIMARY": "Entered for the event. Counts against its quota.",
			"RESERVE": "Ready to step in. Does not count against the quota."
		},
		"enteredHint": "Already entered in competition for this event. Withdraw the entry first."
	},
	"quota": {
		"primaryOf": "Primary {{used}} / {{limit}}",
		"primaryCount_one": "{{n}} primary",
		"primaryCount_other": "{{n}} primary",
		"noLimit": "No limit",
		"full": "Quota filled",
		"fullHint": "The quota for this event is full. Make someone else Reserve first.",
		"left_one": "{{n}} place left",
		"left_other": "{{n}} places left",
		"over_one": "{{n}} over the quota",
		"over_other": "{{n}} over the quota",
		"reserves_one": "{{n}} reserve",
		"reserves_other": "{{n}} reserves",
		"entryQuota_one": "{{n}} entry competes",
		"entryQuota_other": "{{n}} entries compete",
		"entryQuotaHint": "Entries per organization that compete (the entry quota). The Primary count above is the shortlist quota.",
		"ratio": "{{used}} / {{limit}}"
	},
	"refusal": {
		"not_in_scope": "You cannot change this athlete's entries.",
		"mark_required": "This event has a qualifying standard. Enter the athlete's best record to make them Primary, or make them Reserve.",
		"mark_required_standard": "The qualifying standard is {{standard}}. Enter the athlete's best record to make them Primary, or make them Reserve.",
		"below_standard": "This best record does not meet the qualifying standard. Primary needs a record at the standard or better; Reserve needs none.",
		"below_standard_marks": "{{mark}} does not meet the qualifying standard of {{standard}}. Primary needs a record at the standard or better; Reserve needs none.",
		"deadline_passed": "The shortlist deadline has passed. Only the host can change entries now."
	},
	"guide": {
		"title": "Shortlist statuses",
		"roles": "Entries",
		"rolesNote": "Per athlete, per event.",
		"pending": "Not saved",
		"pendingHint": "Changed here and waiting for Save changes.",
		"refused": "Not saved: refused",
		"refusedHint": "The change was refused. The reason is under the row.",
		"deadline": "Deadline"
	},
	"sport": {
		"subtitle": "{{org}} · Shortlist",
		"back": "Back to Shortlist",
		"csv": "CSV",
		"csvName": "shortlist-{{sport}}.csv",
		"readOnly": "You can view these entries but not change them.",
		"tiles": {
			"aria": "Sport summary",
			"athletes": "Approved athletes",
			"athletesNote": "With an approved card",
			"primary": "Primary",
			"mw": "{{m}} M · {{w}} W",
			"events": "Events entered",
			"of": "of {{n}}"
		},
		"view": {
			"label": "View",
			"event": "By event",
			"athlete": "By athlete"
		},
		"eventPicker": "Event",
		"allEvents_one": "All events ({{n}})",
		"allEvents_other": "All events ({{n}})",
		"eventOption": "{{name}} · {{gender}} ({{n}})",
		"noAthletesTitle": "No approved athletes for this sport",
		"noAthletesHint": "Athletes appear here once their accreditation is approved.",
		"noEventsTitle": "No events for this sport",
		"noEventsHint": "Events are set up by the host under Game Settings.",
		"fill": {
			"label": "Show events",
			"all": "All events",
			"empty": "No Primary yet",
			"partial": "Places left",
			"full": "Primary filled",
			"noneTitle": "No event matches this filter.",
			"showAll": "Show all events"
		}
	},
	"event": {
		"none": "No athletes yet. Add one below.",
		"noneFit": "No approved athlete fits this event.",
		"entered": "In competition",
		"controlLabel": "Role in {{event}} for {{name}}",
		"add": "Add athlete",
		"addLabel": "Add an athlete to {{event}}",
		"noneYet": "No athletes in this event yet.",
		"addPrimary": "Add as Primary — pick a name",
		"addReserve": "Primary places are full — pick a name to add as Reserve",
		"addAsPrimary": "Add {{name}} to {{event}} as Primary",
		"addAsReserve": "Add {{name}} to {{event}} as Reserve"
	},
	"athletes": {
		"search": "Name or Card Number",
		"col": {
			"no": "No.",
			"card": "Card No.",
			"name": "Name",
			"events": "Events and role"
		},
		"entries": "Entries",
		"chips": {
			"role": "Role",
			"primary": "Primary",
			"reserve": "Reserve only",
			"none": "Not entered",
			"gender": "Gender"
		},
		"empty": {
			"filteredTitle": "No athletes match",
			"clear": "Clear filters",
			"noneTitle": "No athletes in this event yet"
		}
	},
	"allAthletes": {
		"col": {
			"sports": "Sport"
		},
		"openIn": "Open in {{sport}}",
		"eventInSport": "{{event}} ({{sport}})",
		"sport": "Sport",
		"allSports": "All sports",
		"sportOption": "{{name}} ({{n}})",
		"showing": "Showing {{shown}} of {{n}}",
		"loadMore": "Load more",
		"emptyTitle": "No approved athletes yet",
		"emptyHint": "Athletes appear here once their cards are approved."
	},
	"sheet": {
		"description": "{{card}} · {{gender}}",
		"openRecord": "Open record",
		"done": "Done",
		"saveHint": "Changes are saved with Save changes at the bottom of the page."
	},
	"save": {
		"done_one": "{{n}} change saved",
		"done_other": "{{n}} changes saved",
		"partial_one": "{{saved}} saved. {{n}} change was refused; see the marked row.",
		"partial_other": "{{saved}} saved. {{n}} changes were refused; see the marked rows."
	},
	"leave": {
		"title": "Discard your changes?",
		"body_one": "{{n}} change has not been saved. It will be lost.",
		"body_other": "{{n}} changes have not been saved. They will be lost.",
		"stay": "Stay on this page",
		"discard": "Discard and leave"
	},
	"bar": {
		"label": "Entries",
		"primary_one": "{{n}} primary athlete",
		"primary_other": "{{n}} primary athletes",
		"events": "{{entered}} of {{total}} events entered",
		"unsaved_one": "{{n}} unsaved change",
		"unsaved_other": "{{n}} unsaved changes",
		"unsavedHint": "Save to record them. Nothing is sent until you do.",
		"refused_one": "{{n}} change was refused. Fix or discard it.",
		"refused_other": "{{n}} changes were refused. Fix or discard them.",
		"discard": "Discard",
		"save_one": "Save {{n}} change",
		"save_other": "Save {{n}} changes",
		"invalidRecords_one": "{{n}} best record can't be read. Fix it to save.",
		"invalidRecords_other": "{{n}} best records can't be read. Fix them to save."
	},
	"standard": {
		"label": "Qualifying: {{mark}} or better",
		"lowerHint": "Lower is better: a best record at or under this mark qualifies.",
		"higherHint": "Higher is better: a best record at or over this mark qualifies."
	},
	"record": {
		"label": "Best record",
		"inputLabel": "Best record in {{event}} for {{name}}",
		"value": {
			"TIME": "{{mark}}",
			"DISTANCE": "{{mark}} m",
			"WEIGHT": "{{mark}} kg",
			"POINTS": "{{mark}} pts",
			"SCORE": "{{mark}}"
		},
		"unit": {
			"DISTANCE": "m",
			"WEIGHT": "kg",
			"POINTS": "pts"
		},
		"hint": {
			"TIME": "Type a time, like 1:58.50 or 10.75.",
			"DISTANCE": "Type metres, like 7.20.",
			"WEIGHT": "Type kilograms, like 250.",
			"POINTS": "Type points, like 8123.",
			"SCORE": "Type a score, like 13.533."
		},
		"verdict": {
			"meets": "Meets the standard",
			"below": "Below the standard",
			"invalid": "Can't read this mark",
			"empty": "No record yet"
		},
		"optionalReserve": "Optional for Reserve",
		"details": "Date and competition",
		"detailsAria": "Date and competition of the best record",
		"date": "Date achieved",
		"competition": "Competition",
		"competitionPlaceholder": "e.g. National Championships 2026",
		"belowBadge": "Below standard",
		"belowBadgeHint": "Saved without a best record that meets the qualifying standard."
	},
	"deadline": {
		"tile": "Deadline",
		"none": "No deadline",
		"opens": "Opens {{at}}",
		"state": {
			"none": "No deadline",
			"open": "Open",
			"upcoming": "Not open yet",
			"closed": "Closed"
		},
		"hint": {
			"none": "No deadline is set. Entries can be changed at any time.",
			"open": "Entries can be changed until the deadline.",
			"upcoming": "The shortlist has not opened yet. Entries can be changed once it opens.",
			"closed": "The deadline has passed. Entries are locked; only the host can change them."
		},
		"banner": {
			"closedTitle": "The shortlist deadline passed on {{at}}.",
			"closed": "Entries are locked. Ask the host to extend the deadline.",
			"upcomingTitle": "The shortlist opens on {{at}}.",
			"upcoming": "Entries cannot be changed until then.",
			"adminEdit": "The contingent can no longer change them. As an administrator you still can; every change is recorded."
		}
	}
}
